export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Úspěch"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Chyba"])}
}